// src/components/LanguageSelector.js
import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSelector = () => {
  const { language, switchLanguage } = useLanguage(); // Use switchLanguage from context

  const handleChange = (event) => {
    switchLanguage(event.target.value); // Call switchLanguage to update the language
  };

  return (
    <select 
      value={language} 
      onChange={handleChange} 
      style={{
        padding: '5px',
        fontSize: '14px',
        marginRight: '10px',
        borderRadius: '5px',
        border: '1px solid #ccc',
        background: '#f9f9f9'
      }}
    >
      <option value="uz">UZ</option>
      <option value="en">EN</option>
      <option value="rus">RUS</option>
    </select>
  );
};

export default LanguageSelector;
